import React from 'react';
import Button from "react-bootstrap/Button";
import { motion } from 'framer-motion';
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

const TrainingsTiers = () => {
  const { t } = useTranslation();

     const navigate = useNavigate(); // Initialize navigate
    
      const handleClick = () => {
        navigate("/courses"); // This will navigate to the "/another-page" route
      };

        const handleClick1 = () => {
        navigate("/tiers"); // This will navigate to the "/another-page" route
      };
  const features = t("trainingsTiers.features", { returnObjects: true });
  const featureRows = Array.isArray(features) ? features : [];

  return (
    <div className="max-w-6xl mx-auto px-4 pt-32 sm:pt-40 pb-10"> {/* increased top padding */}
      <h1 className="text-3xl font-bold text-center mb-6">{t("trainingsTiers.title")}</h1>
      
      {/* Descriptive Section */}
      <div className="bg-gray-50 p-6 rounded-lg mb-6">
        <h2 className="text-xl font-semibold mb-3">{t("trainingsTiers.subtitle")}</h2>
        <p className="mb-2">
          <strong>{t("trainingsTiers.desc.singleLabel")}</strong> {t("trainingsTiers.desc.singleText")}
        </p>
        <p className="mb-4">
          <strong>{t("trainingsTiers.desc.tieredLabel")}</strong> {t("trainingsTiers.desc.tieredText")}
        </p>

        {/* CTA Buttons */}
        <div className="flex flex-col sm:flex-row gap-4">         
             <Button onClick={handleClick}>{t("trainingsTiers.buttons.single")}</Button>
           <Button onClick={handleClick1}>{t("trainingsTiers.buttons.tiered")}</Button>
        </div>
      </div>

      {/* Animated Comparison Table */}
      <motion.div
        initial={{ opacity: 0, y: 50 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.8 }}
        className="overflow-x-auto"
      >
        <table className="min-w-full border border-gray-200">
          <thead className="bg-gray-100">
            <tr>
              <th className="border px-6 py-3 text-left font-semibold">{t("trainingsTiers.table.feature")}</th>
              <th className="border px-6 py-3 text-left font-semibold">{t("trainingsTiers.table.single")}</th>
              <th className="border px-6 py-3 text-left font-semibold">{t("trainingsTiers.table.tiered")}</th>
            </tr>
          </thead>
          <tbody>
            {featureRows.map((item, index) => (
              <motion.tr
                key={index}
                className={index % 2 === 0 ? "bg-white" : "bg-gray-50"}
                initial={{ opacity: 0, x: -20 }}
                animate={{ opacity: 1, x: 0 }}
                transition={{ duration: 0.5, delay: index * 0.1 }}
              >
                <td className="border px-6 py-4 font-medium">{item.feature}</td>
                <td className="border px-6 py-4">{item.course}</td>
                <td className="border px-6 py-4">{item.tier}</td>
              </motion.tr>
            ))}
          </tbody>
        </table>
      </motion.div>
    </div>
  );
};

export default TrainingsTiers;
